export default __webpack_public_path__ + "static/media/Avatar-0-noback.ffed97a1.png";